import * as React from 'react';

import { createIcon } from '../Icon';
export const MoveVerticalIcon = createIcon(
  <path d="m3 8l4-4l4 4m-4-4v16m14-4l-4 4l-4-4m4 4V4" />,
  'MoveVerticalIcon'
);
